import React, { useEffect, useRef, useState } from 'react';
import ModelsDropdown from './ModelsDropdown/ModelsDropdown.tsx';
import ModelButton from './ModelButton/ModelButton.tsx';
import {useAppStore} from "../../../../GlobalStore/GlobalStore.ts";

interface ModelsProps {}

const Models: React.FC<ModelsProps> = ({ }) => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const setSettingsObj = useAppStore((state: any) => state.setSettingsObj);
    const { theme, model } = settingsObj;

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<any>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleModelSelect = (model: string) => {
        setSettingsObj({
            model: model
        });
        setIsOpen(false);
    };

    return (
        <div ref={dropdownRef} className="flex flex-col justify-center">
            <ModelButton model={model} theme={theme} setIsOpen={setIsOpen} isOpen={isOpen} />
            <ModelsDropdown handleModelSelect={handleModelSelect} setIsOpen={setIsOpen} isOpen={isOpen} />
        </div>
    );
};

export default Models;
